<template>
    <phoenix-wrapper>
        <div class="content-page w-full">

            <div class="steps-container pt-2 pb-4">
                <div class="steps-title flex justify-around w-full mx-auto font-semibold">
                    <p class="text-black">Authorized lender</p>
                    <p class="text-black mr-5">Bank account</p>
                </div>

                <div class="step-progress flex justify-around my-5">
                    <PhoenixStepProgress :step="1" />
                </div>
            </div>
            
            <div class="white-bg-container bg-white rounded-lg px-10 py-5 sm:px-10 sm:py-10 md:px-20 md:py-20">

                <h2 class="my-5">
                    Congratulations <i>{{ user.first_name }}</i
                    >, we’ve been designated as your authorized lender.
                </h2>

                <p style="max-width: 320px; color: #858585">You are almost done.</p>

                <div class="infos-container flex flex-col gap-1 mt-10">
                    <div class="flex flex-col sm:flex-row gap-1">
                        <PhoenixWelcomeInfo label="Name" :value="user.full_name">
                            <UserIcon />
                        </PhoenixWelcomeInfo>
                        <PhoenixWelcomeInfo label="Amount">
                            <EnvelopIcon />

                            <select
                                v-model="selectedAmount" 
                                name="" 
                                id="" 
                                slot="bottom" 
                                class="amount-select rounded text-[#000] focus:outline-none border border-gray-200 appearance-none bg-transparent p-5 ml-4 mb-4 pl-2 sm:mb-0">
                                <option 
                                    v-for="(amount, key) in getDefaultAmounts" 
                                    :value="key" 
                                    :key="key">
                                    {{ amount | money(0) }}
                                </option>
                            </select>
                        </PhoenixWelcomeInfo>
                    </div>
                    <div class="flex flex-col gap-1">
                        <PhoenixWelcomeInfo label="Email" :value="user.email">
                            <UserIcon />
                        </PhoenixWelcomeInfo>
                    </div>
                </div>

                <!-- Consents Section -->
                <div class="consents-section mt-10">
                    <ConsentsCheckBoxes 
                        ref="consentsComponent"
                        @validation-changed="onValidationChanged"
                    />
                </div>

                <div class="next-step-button mb-10">
                    <button
                        data-testid="continue"
                        :class="`inline-block 
                            w-full bg-terciary
                            rounded-full 
                            text-white 
                            p-5 text-center 
                            no-underline 
                            mt-10 ${loadingClass}`"
                        @click.prevent="nextStepClick()"
                    >
                        <span v-if="!loading">Next Step</span>
                        <span v-else>
                            <i class="fa fa-circle-notch fa-spin" />
                        </span>
                    </button>
                </div>

            </div>
        </div>
    </phoenix-wrapper>
</template>

<script>
import PhoenixWelcomeInfo from "./../../../components/PhoenixWelcomeInfo.vue";
import UserIcon from "./../../../../../components/UserIcon.vue";
import EnvelopIcon from "../../../../../components/GlobalEnvelopIcon.vue";
import PhoenixStepProgress from "../../../components/PhoenixStepProgress.vue";
import ConsentsCheckBoxes from "../../../../../components/ConsentsCheckBoxes.vue";

export default {
    mixins: [
        require("../../../../../mixins/InteractsWithGtag").default,
        require("../../../../../mixins/WelcomeMethods").default,
        require("../../../../../mixins/AddTagToLoan").default,
        require("../../../../../mixins/GetLoansAmountsByState").default,
        require("../../../../../mixins/TrackAmountChanges").default,
        require("../../../../../mixins/PageViewAnalytics").default,
    ],
    props: {
        user: {},
        loan: {},
    },
    components: {
        PhoenixStepProgress,
        PhoenixWelcomeInfo,
        UserIcon,
        EnvelopIcon,
        ConsentsCheckBoxes,
    },
    data() {
        return {
            loading: false,
            selectedAmount: "",
            originalAmount: "",
            allRequiredChecked: false, // Track validation state
            gTagPageName: "AUTHORIZE_LENDER",
        };
    },

    methods: {
        nextStepClick() {
            if (this.allRequiredChecked) {
                this.loading = true;

                // Get consent data from child component
                const consentsData = this.$refs.consentsComponent.getConsentsData();
                
                this.accept(consentsData);
            } else {
                // Show validation error message in consents component
                this.$refs.consentsComponent.showError();
            }
        },

        onValidationChanged(isValid) {
            this.allRequiredChecked = isValid;
        }
    },

    created() {
        this.selectedAmount = this.originalAmount = this.loan.amount;
    },

    computed: {
        loadingClass() {
            return (this.loading || !this.allRequiredChecked) ? "opacity-50 cursor-not-allowed" : "";
        }
    },
    
    mounted() {
        window.dispatchEvent(new Event('resize'));
    },
};
</script>

<style scoped>
.amount-select {
    font-size: 14px;
    max-height: 40px;
    padding-bottom: 3px;
    padding-top: 3px;
    position: relative;
    top: 2px;
    width: calc(100% - 32px);
}

.consents-section {
    border-top: 1px solid #e5e7eb;
    padding-top: 20px;
}
</style>